import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-organization-chips',
  templateUrl: './organization-chips.component.html',
  styleUrl: './organization-chips.component.scss',
  standalone: false
})
export class OrganizationChipsComponent {
  @Input() selectedOrgs: any[] = [];  
  @Input() headerTitle: string = '';
  @Input() headerDescription: string = '';
  @Input() showHeader: boolean = false;
  @Output() removeOrg = new EventEmitter<any>();
  @Output() addOrg = new EventEmitter<void>();
  @Input() tooltip: string = '';

  faTimes = faTimes;

  onRemove(org: any) {
    this.removeOrg.emit(org);
  }

  onAdd() {
    this.addOrg.emit();
  }

  removeAll() {
    this.selectedOrgs.forEach(org => {
      this.removeOrg.emit(org);
    });
  }
}
